<ng-container>
  @if (config) {
  <div class="book-list">
    <qa-grid-data [config]="config">
      <qa-no-entity-info noContent [listInfo]="listInfo"></qa-no-entity-info>
    </qa-grid-data>
  </div>
  }
</ng-container>
